import $ from 'jquery';

let facetsLoaded = false;

setTimeout(() => {
  setTitleAndDescription();
}, 250);


const searchParam = getUrlParams('_search_categories');
const searchFilterContainer = $('.navbar__search-box__container__search-form__inputs__category-filter');

if (searchFilterContainer.length) {
  const filters = searchFilterContainer.find('.navbar__search-box__container__search-form__inputs__category-filter__search-input');
  filters.each((index, el) => {
    if ($(el).attr('value') === searchParam) {
      $(el).prop('checked', true);
    }
  });
}

const subjects = ['pregnancy', 'baby', 'toddler'];

$(document).on('facetwp-loaded', e => {
  subjects.forEach(subject => {
    $(`.facetwp-facet-bonbebe_${subject}_subjects > .facetwp-radio`).on('click', () => {
      setTimeout(() => {
        setTitleAndDescription();
      }, 250);
    });
  });

  const facetNames = ['pregnant', 'tags', 'age'];

  setFacetDisplays(facetNames);

  facetNames.forEach(facetName => {
    $(`.facetwp-facet-knowledge_base_${facetName} > .facetwp-radio`).each((index, el) => {
      showShowMore(index, el);
    })
  });

  subjects.forEach(subject => {
    $(`.facetwp-facet-bonbebe_${subject}_subjects > .facetwp-radio`).each((index, el) => {
      showShowMore(index, el);
    })
  });
});

$('.knowledge-base-filters__filter__more').on('click', e => {
  const $target = $(e.currentTarget);
  $target.addClass('hide');
  const type = $target.attr('data-facet-type');
  if (type.startsWith('bonbebe')) {
    $( `.facetwp-facet-${type} > .facetwp-radio` ).each( ( index, el ) => {
      $( el ).removeClass( 'hide' );
    } );
  }
  $(`.facetwp-facet-knowledge_base_${type} > .facetwp-radio`).each((index, el) => {
    $(el).removeClass('hide');
  });
});

function showShowMore(index, el) {
  if (index > 3) {
    $(el).closest('.facetwp-facet').next('.knowledge-base-filters__filter__more').removeClass('hide');
    $(el).addClass('hide');
  }
}

function setTitleAndDescription() {
  const subjects = ['bonbebe_pregnancy', 'bonbebe_baby', 'bonbebe_toddler'];
  let currentSubject;
  let currentPostType;
  
  subjects.forEach(subject => {
    const urlParams = getUrlParams(`_${subject}_subjects`);
    if (urlParams) {
      currentSubject = urlParams;
      currentPostType = subject;
    }
  });

  if (!currentSubject) {
    currentPostType = $('.knowledge-base__meta').attr('data-post-type');
  }

  const ajaxurl = window.topmerken.ajaxurl;
  $.ajax({
    url: ajaxurl,
    data: { action: 'get_acf_title_and_description', slug: currentSubject, post_type:  currentPostType },
    type: 'post',
    dataType: 'html',
    success: html => {
      $('.knowledge-base__meta').html(html);
    }
  });
}

function getUrlParams(search) {
  const queryString = encodeURIComponent(window.location.search);
  const urlParams = new URLSearchParams(decodeURIComponent(queryString));
  if (urlParams.has(search)) {
    return urlParams.get(search);
  }
  return false;
}

function setFacetDisplays(facetNames) {
  $('.knowledge-base-filters__filter').each((index, element) => {
    facetNames.forEach(facetName => {
      if (facetName === 'tags') return;
      $(element).find($(`.facetwp-facet-knowledge_base_${facetName} .facetwp-display-value`)).each((index, el) => {
        const hasWeeks = $(element).attr('data-has-weeks');
        $(el).html(getHtmlForKBFacet($(el).html(), hasWeeks))
      });
      
      $(element).find($(`.facetwp-facet-knowledge_base_${facetName}_mobile .facetwp-display-value`)).each((index, el) => {
        const hasWeeks = $(element).attr('data-has-weeks');
        $(el).html(getHtmlForKBFacet($(el).html(), hasWeeks))
      })
    });
  });
}

function getHtmlForKBFacet(currentHtml, hasWeeks) {
  if (currentHtml.includes('wek') || currentHtml.includes('maand') || currentHtml.includes('week')) {
    return currentHtml;
  }

  const isPlural = Number(currentHtml) !== 1;

  if (hasWeeks) {
    return `${currentHtml} ${isPlural ? 'weken' : 'week'}`;
  } else {
    return `${currentHtml} ${isPlural ? 'maanden' : 'maand'}`;
  }
}